import { ContentTagsAction } from '../types/ContentTagsAction';
import { ContentTagsBody } from '../types/ContentTagsBody';
import { TagTypesBody } from '../types/TagTypesBody';

interface ContentTagsState {
	list: ContentTagsBody[],
	tagTypes: TagTypesBody[],
};

const initialState: ContentTagsState = {
	list: [],
	tagTypes: [],
};

const contentTagsReducers = (state = initialState, action: ContentTagsAction) => {
	switch (action.type) {
		case 'CONTENT_TAGS_LIST_SUCCESS': {
			let { list } = state;
			let data = action.data ? action.data : [];
			let newList = [...list,...data];
			return { ...state, list: newList }
		}
		case 'CONTENT_TAG_TYPES_LIST_SUCCESS': {
			return { ...state, tagTypes: action.data }
		}
		default:
			return state;
	}
}

export default contentTagsReducers;